<script>
    import { fly } from "svelte/transition";
    import { Button } from "../index";
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">语意按钮</h4>
    <div class="example-body">
        <Button>Default</Button>
        <Button color="primary">Primary</Button>
        <Button color="warning">Warning</Button>
        <Button color="danger">Danger</Button>
    </div>
    <h4 class="example-title">块级按钮</h4>
    <div class="example-body">
        <Button color="primary" size="large" block>块级按钮</Button>
    </div>
    <h4 class="example-title">按钮尺寸</h4>
    <div class="example-body">
        <Button size="mini" color="primary">mini</Button>
        <Button size="small" color="primary">small</Button>
        <Button size="middle" color="primary">middle</Button>
        <Button size="large" color="primary">large</Button>
    </div>
</div>

<style lang="less">
    @import "./example.less";
</style>
